const base = 'https://tossp.yoooooo.com/index.php/index/xingxiang_action'

export function normalizeXingxiangId (value) {
  if ((typeof value !== 'string' && typeof value !== 'number') || !/^[1-9][0-9]*$/.test(String(value)) || Number(value) > 4294967295) {
    throw new Error('智体ID无效，请从智体列表重新进入')
  }
  return Number(value)
}

export function isHttpUrl (value) {
  if (typeof value !== 'string' || !/^https?:\/\//i.test(value) || /\s/.test(value)) return false
  try {
    const url = new URL(value)
    return Boolean(url.hostname) && (url.protocol === 'http:' || url.protocol === 'https:')
  } catch (e) { return false }
}

export function createXingxiangActionApi (http, Form = FormData) {
  async function post (method, values) {
    const body = new Form()
    Object.keys(values).forEach(key => body.append(key, String(values[key])))
    const response = await http.post(base + '/' + method, body)
    const result = response.data
    if (!result || Number(result.code) !== 200) throw new Error((result && result.msg) || '请求失败，请重试')
    return result.data
  }
  return {
    list (id) { return post('actionList', { xingxiang_id: normalizeXingxiangId(id) }) },
    create (id, form) {
      const name = typeof form.name === 'string' ? form.name.trim() : ''
      const url = typeof form.action_url === 'string' ? form.action_url.trim() : ''
      if (!name || Array.from(name).length > 255) throw new Error('请填写动作名称，最多255个字符')
      if (!isHttpUrl(url) || new Blob([url]).size > 2048) throw new Error('请填写有效的HTTP或HTTPS动作链接，最多2048字节')
      return post('actionCreate', { xingxiang_id: normalizeXingxiangId(id), name, action_url: url })
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/xingxiangAction.js